var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_vm._t("label",[(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]),_vm._t("default",[_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.value))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }